<div class="d-flex flex-row gap-3">
  <kendo-floatinglabel text="Name">
    <kendo-textbox [(value)]="name">
    </kendo-textbox>
  </kendo-floatinglabel>
  <kendo-floatinglabel text="Target">
    <kendo-textbox [(value)]="target">
    </kendo-textbox>
  </kendo-floatinglabel>
  <div class="mt-4">
    <ece-btn-icon [icon]="'hyperlink-light-dialog'" title="{{ 'circ_details_documents_addLink' | i18n }}"
    (click)="addHyperlink()"></ece-btn-icon>
  </div>
</div>
<div class="validation-error">
  {{ errorText | i18n }}
</div>